import { render, staticRenderFns } from "./endpoint.vue?vue&type=template&id=052b6600&scoped=true&"
import script from "./endpoint.vue?vue&type=script&lang=js&"
export * from "./endpoint.vue?vue&type=script&lang=js&"
import style0 from "./endpoint.vue?vue&type=style&index=0&id=052b6600&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052b6600",
  null
  
)

export default component.exports